export const MSA_IMAGE_DIMENSIONS = { width: 400, height: 400 };
export const OUTFIT_RECO_REF_TAG = 'outfit-reco';

export const INLINE_OUTFIT_RECO_HEIGHT = 80;
export const DISPLAY_OUTFIT_COUNT = 4;
